// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/ticket.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/ticket'

import { Icon, type IconComponentProps } from '../icon'

export const TicketIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
